/*
* Author: GM
* Component: ModalHelper
*/


!function ($) {
    "use strict";

    var ModalHelper = function () {
        console.log('ModalHelper.Constructor');
        this.$body = $("body");
    };


    /* Initializing */
    ModalHelper.prototype.init = function () {
        console.log('ModalHelper.Initializing');
    };

    ModalHelper.prototype.Id = function () {
        var now = new Date();
        var components = [
            now.getFullYear(),
            now.getMonth(),
            now.getDate(),
            now.getHours(),
            now.getMinutes(),
            now.getSeconds(),
            now.getMilliseconds()
        ];

        return components.join("");
    }


    ModalHelper.prototype.Standard = function (options, callback, onHide) {

        options = $.extend({
            id: 'M' + this.Id(),
            title: 'Standard',
            size: 'modal-lg',//modal-lg, modal-sm,
            btnTheme: 'primary',
            body: ''
        }, options);

        $.TempHelper.get('Modal.Standard', options, function (html) {

            $.ModalHelper.$body.append(html);

            var $modal = $('#' + options.id).modal();

            $modal.on('hidden.bs.modal', function () {
                $modal.remove();

                if ($.isFunction(onHide))
                    onHide($modal);
            });

            if ($.isFunction(callback))
                callback($modal);
        });
    };


    $.ModalHelper = new ModalHelper;
    $.ModalHelper.Constructor = ModalHelper;
}(window.jQuery),

    //initializing ModalHelper
    function ($) {
        "use strict";
        $.ModalHelper.init();
    }(window.jQuery);


